import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import async from 'async';

import { Controller } from '../../common/Controller';
import { UiHelper } from '../../common/helpers/UiHelper';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { CustomFormFieldsDialog } from './CustomFormFieldsDialog';
import { orgData } from './Data';
import { Headerbar } from './Headerbar';
import { TableList } from './TableList';
import { Stats } from './Stats';
import { PopOver } from './PopOver';

import { Styles } from './Styles'
import { CommonStyles } from '../../styles/Styles';

export class GuestUsers extends Component {
  constructor(props) {
    super(props);
    this.orgId = this.props.match.params ? this.props.match.params.id : null;
    this.userId = Controller.get().userMgr().getUserId();
    this.responseByKey = {}
    this.state = {
      updateItemDialog: false,
      dialogAction: '',
      dialogTitle: '',
      selectedItem: {},
      anchorEl: null,
      confirmDeleteView: false,
      inProcess: false,
      fetchState: ApiHelper.State.LOADING,
    }
  }

  componentDidMount() {
    this.fetchItems();
  }

  fetchItems = () => {
    const queryParams = { userId: this.userId, type: 'GUEST' }
    const orgId = this.orgId
    async.parallel(
      [
        function (callback) {
          ApiHelper.call(
            { method: 'GET', endPoint: ApiHelper.makeUrlPath(['vehicles'], queryParams) }, callback)
        },
        function (callback) {
          ApiHelper.call(
            { method: 'GET', endPoint: ApiHelper.makeUrlPath(['orgs', orgId]) }, callback)
        }
      ],
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        this.org = results[1]

        this.setState({
          items: results[0],
          logoUrl: results[1].logoUrl,
          fetchState: ApiHelper.State.READY
        })
      }.bind(this))
  }

  resetToDefaultValues = () => {
    this.responseByKey = {}
    this.setState({
      updateItemDialog: false,
      inProcess: false,
      dialogAction: '',
      dialogTitle: '',
      selectedItem: {},
      anchorEl: null,
      confirmDeleteView: false,
    })
  }

  showAddItemDialog = () => {
    this.setState({
      updateItemDialog: true,
      dialogTitle: 'Add a Guest',
      dialogAction: 'add',
    })
  }

  showConfirmDeleteView = () => {
    this.setState({
      confirmDeleteView: true,
      inProcess: false
    })
  }

  showDeleteItemDialog = () => {
    this.responseByKey = this.state.selectedItem
    if(this.state.selectedItem.ownerInfo) {
      this.responseByKey.name = this.state.selectedItem.ownerInfo.name
      this.responseByKey.email = this.state.selectedItem.ownerInfo.email
      this.responseByKey.phone = this.state.selectedItem.ownerInfo.phone
    }
    this.setState({
      anchorEl: null,
      updateItemDialog: true,
      dialogTitle: 'Edit Member Details',
      dialogAction: 'delete',
    })
  }

  showUpdateMemberDialog = () => {
    this.responseByKey = this.state.selectedItem
    this.setState({
      anchorEl: null,
      updateItemDialog: true,
      dialogTitle: 'Edit Member Details',
      dialogAction: 'edit',
    })
  }

  onPopOverClick = (key) => {
    if (key === 'edit') {
      this.showUpdateMemberDialog()
    } else if (key === 'delete') {
      this.showDeleteItemDialog()
    }
  }

  editClick = (e, item) => {
    this.setState({
      anchorEl: e.currentTarget,
      selectedItem: item
    })
  }

  editClickClose = () => {
    this.setState({ anchorEl: null })
  }

  setValue = (value, key) => {
    this.responseByKey[key] = value
  }

  addItem = () => {
    this.setState({
      inProcess: true
    })
    let options = {}
    const id = this.state.selectedItem ? this.state.selectedItem._id : null
    if (!id) {
      options = {
        method: 'POST',
        endPoint: ApiHelper.makeUrlPath(['vehicles']),
        jsonBody: {
          vechicleData: {
            lp: this.responseByKey.lp,
            name: this.responseByKey.name,
            email: this.responseByKey.email,
            phone: this.responseByKey.phone,
            orgId: this.orgId
          }
        }
      }
    } else {
      const body = {
        userData: {
          name: this.responseByKey.name,
          email: this.responseByKey.email,
          phone: this.responseByKey.phone,
          orgId: this.orgId
        }
      }
      options = {
        method: 'PUT',
        endPoint: ApiHelper.makeUrlPath(['vehicles', id]),
        jsonBody: body
      }
    }
    Helper.removeNullValues(options.jsonBody.userData)
    console.log('options', options)
    ApiHelper.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: msg,
          errCode: err.respCode,
          inProcess: false,
        })
        return
      } else {
        this.resetToDefaultValues()
        this.fetchItems();
      }
    }.bind(this))
  }

  deleteMember = () => {
    const id = this.state.selectedItem ? this.state.selectedItem.userlpId : null
    if (!id) {
      return
    }
    this.setState({
      inProcess: true
    })
    const options = {
      method: 'DELETE',
      endPoint: ApiHelper.makeUrlPath(['vehicles', id]),
    }
    ApiHelper.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: msg,
          errCode: err.respCode,
          inProcess: false,
        })
        return
      } else {
        this.resetToDefaultValues()
        this.fetchItems();
      }
    }.bind(this))
  }

  setUser = (item) => {
    if (item) {
      this.setState({
        selectedItem: item,
        updateItemDialog: true,
        dialogAction: 'edit',
        dialogTitle: 'Edit Member Details',
      })
    } else {
      this.setState({
        selectedItem: item,
        updateItemDialog: true,
        dialogAction: 'add',
        dialogTitle: 'Add a Member',
      })
    }
  }

  renderItemDialog = () => {
    const formFields = []
    for (const key in orgData.userFields) {
      formFields.push(orgData.userFields[key])
    }
    return (
      <CustomFormFieldsDialog
        onClose={this.resetToDefaultValues}
        dialogOpen={this.state.updateItemDialog}
        dialogTitle={this.state.dialogTitle}
        confirmDeleteView={this.state.confirmDeleteView}
        inProcess={this.state.inProcess}
        selectedItem={this.state.selectedItem}
        deleteItem={() => this.deleteMember()}
        action={this.state.dialogAction}
        showConfirmDeleteView={this.showConfirmDeleteView}
        responseByKey={this.responseByKey}
        onSuccess={this.addItem}
        formFields={formFields}
        enableValidation={this.state.dialogAction === 'delete' ? false : true}
        formDisabled={this.state.dialogAction === 'delete' ? true : false}>
      </CustomFormFieldsDialog>
    )
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView = () => {
    const open = Boolean(this.state.anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
      <div className={css(CommonStyles.outerMainContainer)}>
        <Headerbar
          title={this.org.name}
          items={this.state.items}
          buttonOneAction={this.showAddItemDialog}
          buttonOneTitle={'ADD NEW GUEST'}
          inProcess={this.state.inProcess}></Headerbar>

        <div className={css(CommonStyles.innerMainContainer)}>
          <div className={css(Styles.innerMainContent)}>
            <Stats
              title={this.org.name}
              logoUrl={this.state.logoUrl}
              users={this.state.items}
            />

            {this.state.items.length !== 0 &&
              <TableList
                tableColumnTitles={orgData.tableColumnTitles}
                items={this.state.items}
                editClick={this.editClick}
                id={id}
              />
            }
          </div>
        </div>

        {this.renderItemDialog()}

        <PopOver
          id={id}
          open={open}
          items={orgData.popOverFields}
          anchorEl={this.state.anchorEl}
          onPopOverClick={this.onPopOverClick}
          editClickClose={this.editClickClose}
        />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/screens/GuestUsersDetails/GuestUsers.js